import { Box, Container, Stack } from '@dtx-company/design-system/src'
import { CodePreview } from './CodePreview/CodePreview'
import { FormActionButtons } from './FormActionButtons/FormActionButtons'
import { GeneratorHeading } from './GeneratorHeading/GeneratorHeading'
import { NAV_V2_HEIGHT } from '@dtx-company/true-common/src/constants/layout'
import { ProgressBarDesktop } from './GeneratorHeading/ProgressBar/ProgressBarDesktop'
import { ProgressBarMobile } from './GeneratorHeading/ProgressBar/ProgressBarMobile'
import { ScrollableContainer } from './ScrollableContainer/ScrollableContainer'
import { VerticalScrollProgress } from './ScrollableContainer/VerticalScrollProgress'
import { setHideFooter } from '@dtx-company/inter-app/src/redux/slices/settings-slice'
import { setShowStaticContent } from '@dtx-company/inter-app/src/redux/slices/homePageSlice'
import { useDispatch } from 'react-redux'
import { useGlobalServices } from '@app/common/src/hooks/useGlobalServices'
import { useScreenSizeBreakpoints } from '@app/common/src/hooks/useScreenSizeBreakpoints'
import { useSelector } from '@xstate/react'
import React, { FC, useEffect } from 'react'

export const LoggedOutCodeGenerator: FC = () => {
  const { isMobile } = useScreenSizeBreakpoints()
  const dispatch = useDispatch()
  const { locgService } = useGlobalServices()
  const displayFormActionButtons = useSelector(locgService, state => !state.matches('auth'))

  useEffect(() => {
    dispatch(setHideFooter(isMobile))
    dispatch(setShowStaticContent(!isMobile))

    return () => {
      dispatch(setShowStaticContent(true))
      dispatch(setHideFooter(false))
    }
  }, [isMobile, dispatch])

  return (
    <Container maxWidth="xl" disableGutters>
      <Stack
        sx={theme => ({
          height: `calc(100vh - ${NAV_V2_HEIGHT}px) `,
          width: '100%',
          maxHeight: {
            md: theme.spacing(209)
          },
          minHeight: {
            md: theme.spacing(150)
          }
        })}
      >
        <GeneratorHeading />
        <Box
          sx={{
            display: {
              xs: 'none',
              md: 'block'
            },
            my: 4
          }}
        >
          <ProgressBarDesktop />
        </Box>
        <Stack
          direction={{
            xs: 'column',
            md: 'row'
          }}
          sx={{
            width: '100%',
            flex: 1,
            overflow: 'hidden'
          }}
        >
          <CodePreview />
          <Box
            sx={{
              display: {
                xs: 'block',
                md: 'none'
              },
              mb: 4
            }}
          >
            <ProgressBarMobile />
          </Box>
          <Box
            sx={{
              position: 'relative',
              flex: {
                xs: 1,
                md: 1.5,
                lg: 1
              },
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              overflow: 'hidden',
              height: '100%'
            }}
          >
            <VerticalScrollProgress />
            <ScrollableContainer />
            {displayFormActionButtons && <FormActionButtons />}
          </Box>
        </Stack>
      </Stack>
    </Container>
  )
}
